<!--
 * @Author: tfq
 * @Date: 2025-09-23 10:38:22
 * @LastEditTime: 2026-01-20 14:41:02
 * @Description: 
-->
<template>
  <div class="main">
    <div class="sourceInfo">
      <TitleModel title="溯源信息" />
      <div class="bottom">
        <div class="right">
          <div v-for="(item, index) in description" :key="index" class="detailBox">
            <Detail :description="item" :isLast="index === description.length - 1"></Detail>
            <!-- <img v-lazy="require(`../../../assets/sourceProduct.png`)" alt="" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Detail from "./detail";
import TitleModel from "../TitleModel.vue";

export default {
  props: ["description"],
  components: { Detail, TitleModel },
  data() {
    return {};
  },
  created() { },
  mounted() { },

  methods: {},
};
</script>

<style lang="less" scoped>
.sourceInfo {
  margin-top: 24px;
  background: #fff;
  padding: 0 52px;
}
</style>
